// extracted by mini-css-extract-plugin
export default {"highlighted":"Advantage_highlighted__6zzHg","smallHeading":"Advantage_smallHeading__U7Bs7","advStatus":"Advantage_advStatus__gwUhR","enrolled":"Advantage_enrolled__cozFa"};